<template>
    <div class="CampaignListInfluencer flex w-full flex-wrap mt-5 pt-5">
        <div
            v-for="campaign in [...campaigns]"
            :key="campaign.id"
            class="cursor-pointer w-full md:w-1/2 px-2"
            style="background: none; border: 0; margin-bottom: 80px;"
            @click="open(campaign, $event)"
        >
            <div
                class="CampaignCard__content__inner bg-white"
                :class="{
                    /*'--has-overlay': campaign.influencer_has_insufficient_reach*/
                }"
            >
                <div class="w-full" style="padding: 30px;">
                    <div class="flex w-full">
                        <div class="w-1/2">
                            <img
                                class="rounded-full w-20"
                                :src="campaign.brand.avatar_url"
                                :alt="campaign.brand.name"
                            />

                            <p
                                style="font-weight: 600;margin: 10px 30px 20px 0;font-size: 18px; word-break: break-word;"
                            >
                                {{ campaign.brand.name }}
                            </p>
                        </div>
                        <div class="w-1/2">
                            <div
                                class="bg-gray-50"
                                :style="'background-image: url(' + campaign.image_url + ')'"
                                style="background-size: cover; background-position: center; margin-top: -60px;width: 100%; height: auto; aspect-ratio: 1/1;"
                            />
                        </div>
                    </div>

                    <div>
                        <p class="font-bold">{{ campaign.name }}</p>

                        <div
                            class="mt-2 line-clamp-4 description-html"
                            v-html="campaign.description"
                        ></div>
                    </div>

                    <div style="margin-top: 20px;">
                        <div class="flex">
                            <div>
                                <img
                                    src="/img/interests-icon.png"
                                    alt="interests"
                                    style="width: 50px;"
                                />
                            </div>
                            <p style="line-height: 45px;margin-left: 10px;font-weight: 600;">
                                Verdensmål
                            </p>
                        </div>
                        <div class="interests-wrapper">
                            <div
                                v-for="interest in campaign.interests"
                                class="interest-box"
                                style="
                                            display: block;
                                            width: calc(25% - 10px);
                                            float: left;
                                            margin: 10px;
                                            margin-left: 0;
                                    "
                            >
                                <img
                                    :src="'/img/interests/' + interest.id + '.png'"
                                    :alt="interest.name"
                                />
                            </div>
                            <div style="clear: both;" />
                        </div>

                        <CampaignListTrophies
                            v-if="hasRequiredTrophiesFor(campaign)"
                            :required-trophies="requiredTrophiesFor(campaign)"
                        />

                        <!-- <div
                            v-if="campaign.reach_required"
                            style="flex-wrap: wrap;"
                            class="flex mt-5"
                        >
                            <div>
                                <span
                                    style="color: #1825d8;font-size: 30px;margin-right: 10px;"
                                    :class="campaign.platform ? campaign.platform.icon : ''"
                                ></span>
                            </div>
                            <div style="font-size: 14px;line-height: 1.2;">
                                <p class="font-bold">Minimum amount of followers</p>
                                <p>
                                    {{ campaign.reach_required }}
                                </p>
                            </div>
                        </div> waitting build live -->
                        <div v-if="campaign.reach_required" class="flex w-full mt-5">
                            <div class="flex">
                                <span
                                    style="color: #1825d8;font-size: 30px;margin-right: 10px;"
                                    :class="campaign.platform ? campaign.platform.icon : ''"
                                ></span>
                                <div style="font-size: 14px;line-height: 1.2;">
                                    <p class="font-bold">
                                        Foretrukket minimum antal
                                        {{ campaign.platform.reach_name | lowercase }} på
                                        {{
                                            campaign.platform.name === 'Instagram Business'
                                                ? 'instagram'
                                                : campaign.platform.name | lowercase
                                        }}
                                    </p>
                                    <p>{{ campaign.reach_required }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-between mt-5">
                            <div class="flex flex-wrap">
                                <div>
                                    <span class="mr-2.5 block">
                                        <img
                                            src="/img/icons/clock.svg"
                                            alt="info"
                                            style="width: 25px;"
                                        />
                                    </span>
                                </div>
                                <div style="font-size: 14px;line-height: 1.2;">
                                    <p class="font-bold">Ansøgningsfrist</p>
                                    <p>
                                        {{
                                            new Date(campaign.expires_at).toLocaleDateString(
                                                'da-DK'
                                            )
                                        }}
                                    </p>
                                </div>
                            </div>

                            <button
                                class=""
                                style="background: #ff00a7;color: white;padding: 3px 12px;line-height: 1.6;"
                            >
                                Se job
                            </button>
                        </div>
                    </div>

                    <!-- Can apply-->
                    <!--
                    <div class="flex v-bottom">
                        <div class="lead flex-1 m-0 font-bold">
                            <Amount
                                v-if="campaign.influencer_can_apply"
                                :value="campaign.influencer_profit"
                            >
                                &nbsp;
                            </Amount>
                        </div>
                        <div class="text-purple-500">
                            <i class="fa fa-search-plus"></i> Vis kampagne
                        </div>
                    </div>
                    -->
                </div>
            </div>

            <!-- Insufficient reach -->
            <!--
            <div
                v-if="campaign.influencer_has_insufficient_reach"
                class="CampaignCard__content__overlay"
            >
                <div>
                    <span class="cool-emoji">😎</span>
                </div>
                <div>
                    <h3>
                        Du skal have minimum
                        <span class="underline">
                            {{ campaign.reach_required }}
                            {{ campaign.platform.reach_name | lowercase }}
                        </span>
                        for at anmode om dette job
                    </h3>
                </div>
                <div>
                    <a :href="schoolUrl" class="btn btn-primary">
                        Gå til influentskolen <i class="fa fa-arrow-right" />
                    </a>
                </div>
            </div>
            -->
        </div>

        <CampaignShowModal
            v-if="currentModal === 'show'"
            :campaign="currentModalParams.campaign"
            :user="user"
            @close="handleModalClose"
        />

        <CampaignConnectChannelModal
            v-if="currentModal === 'connect-channel'"
            :platform="currentModalParams.platform"
            @close="handleModalClose"
        />
    </div>
</template>

<style lang="less" type="text/less">
.CampaignListInfluencer .CampaignCard__content__inner {
    min-height: 200px; // Otherwise overlay will overflow
}
</style>

<script type="text/babel">
import Amount from 'dashboard-js/components/utilities/Amount'
import CampaignCard from 'dashboard-js/components/campaigns/CampaignCard'
import CampaignConnectChannelModal from 'dashboard-js/components/campaigns/CampaignConnectChannelModal'
import CampaignShowModal from 'dashboard-js/components/campaigns/CampaignShowModal'
import CampaignListTrophies from 'dashboard-js/components/campaigns/CampaignListTrophies'
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'
import RequiredTrophies from 'dashboard-js/mixins/RequiredTrophies'
import CampaignImage from 'dashboard-js/components/campaigns/CampaignImage.vue'

export default {
    components: {
        CampaignImage,
        Amount,
        CampaignConnectChannelModal,
        CampaignCard,
        CampaignShowModal,
        CampaignListTrophies,
    },

    mixins: [ManagesModalState, RestoreOnPageBack, RequiredTrophies],

    props: ['campaigns', 'user', 'initialOpenCampaignId'],

    data() {
        return {
            hasHandledInitialOpenCampaign: false,
        }
    },

    mounted() {
        this.openInitialCampaignIfNeeded()
    },

    watch: {
        campaigns() {
            this.openInitialCampaignIfNeeded()
        },
    },

    computed: {
        schoolUrl() {
            return route('influencer.school').toString()
        },
    },

    methods: {
        handleModalClose() {
            this.closeModal()
            this.resetOpenCampaignQuery()
        },
        resetOpenCampaignQuery() {
            const currentUrl = new URL(window.location.href)

            if (!currentUrl.searchParams.has('openCampaign')) {
                return
            }

            currentUrl.searchParams.delete('openCampaign')
            const queryString = currentUrl.searchParams.toString()
            const normalizedUrl = `${currentUrl.pathname}${queryString ? `?${queryString}` : ''}${
                currentUrl.hash
            }`

            window.history.replaceState({}, document.title, normalizedUrl)
        },
        openInitialCampaignIfNeeded() {
            if (this.hasHandledInitialOpenCampaign || !this.initialOpenCampaignId) {
                return
            }

            const campaignId = parseInt(this.initialOpenCampaignId)
            const currentCampaign = (this.campaigns || []).find(
                campaign => parseInt(campaign.id) === campaignId
            )

            if (currentCampaign) {
                this.hasHandledInitialOpenCampaign = true
                this.openModal('show', { campaign: currentCampaign })
                return
            }

            axios
                .get(`/api/campaigns/${campaignId}`)
                .then(response => {
                    this.hasHandledInitialOpenCampaign = true
                    this.openModal('show', { campaign: response.data.data || response.data })
                })
                .catch(() => {
                    this.hasHandledInitialOpenCampaign = true
                })
        },
        open(campaign, event) {
            // If a-tag was clicked do nothing
            if (event.target.localName === 'a' || event.target.closest('a')) {
                return
            }

            // if (campaign.influencer_has_insufficient_reach) {
            //     return NavigationProvider.go(route('influencer.school'))
            // }

            campaign.influencer_can_apply
                ? this.openModal('show', { campaign: campaign })
                : this.openModal('connect-channel', { platform: campaign.platform })
        },
    },
}
</script>
